import {
    baseScalesOptions,
    chartColors,
    commonTooltipOptions,
} from "@/utils/chartConfig";
import { useMemo } from "react";
import type { testScore } from "@/features/dashboard/types.api";
import type { comparativeFilterKey } from "../types.props";

const getDefaultComparativeChartOptions = () => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            ...baseScalesOptions.x,
            ticks: { ...baseScalesOptions.x.ticks, font: { size: 12 } },
        },
        y: {
            ...baseScalesOptions.y,
            beginAtZero: true,
            max: 100,
            ticks: { ...baseScalesOptions.y.ticks, font: { size: 12 } },
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            ...commonTooltipOptions,
        },
    },
});

export const useComparativeChart = (
    tests: testScore[] | undefined,
    currentView: comparativeFilterKey,
) => {
    const chartData = useMemo(() => {
        if (!tests) {
            return { labels: [], datasets: [] };
        }
        return {
            labels: tests.map((t) => t.name),
            datasets: [
                {
                    label: "Tu puntaje",
                    data: tests.map((t) => Number(t.score)),
                    backgroundColor: chartColors.primaryLight,
                },
                {
                    label:
                        currentView === "vsInstitution"
                            ? "Promedio institución"
                            : "Promedio global",
                    data: tests.map((t) => Number(t.comparative_data[currentView])),
                    backgroundColor: chartColors.secondaryLight,
                },
            ],
        };
    }, [tests, currentView]);

    const chartOptions = useMemo(() => getDefaultComparativeChartOptions(), []);

    return { chartData, chartOptions };
};
